import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class GlAccMappingService extends DatabaseGwService {
  URL_PATH: string = '/gl-acc-mappings';

}
